export default __webpack_public_path__ + "static/media/afct bottles1.a1b169ad.webp";